/**
 * @generated SignedSource<<4b682bf62f5b65623b255310f9d17bef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PublishReportInput = {
  reportId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type PublishReportMutation$variables = {
  input: PublishReportInput;
};
export type PublishReportMutation$data = {
  readonly publishReport: {
    readonly draftState: string | null;
    readonly publishedAt: string | null;
    readonly locked: boolean | null;
  } | null;
};
export type PublishReportMutation = {
  variables: PublishReportMutation$variables;
  response: PublishReportMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PublishReportPayload",
    "kind": "LinkedField",
    "name": "publishReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PublishReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PublishReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d885d7d4c288b0e3678b5ffecd6f3560",
    "id": null,
    "metadata": {},
    "name": "PublishReportMutation",
    "operationKind": "mutation",
    "text": "mutation PublishReportMutation(\n  $input: PublishReportInput!\n) {\n  publishReport(input: $input) {\n    draftState\n    publishedAt\n    locked\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc30a6dc4380b7a9cce12109bde339e4";

export default node;
